// Special Option Keys:
export const BASE_URL_OPTION_KEY = 'base_url';
export const CREDENTIAL_OWNER_OPTION_KEY = 'credential_owner';
export const CUSTOMER_LIST_ID_OPTION_KEY = 'customer_list_id';
export const DISPLAY_NAME_OPTION_KEY = 'service_node_display_name';
export const DISPLAY_NAME_OPTION_NAME = 'Service Node Display Name';
export const MODULES_OPTION_KEY = 'modules';
export const TAGS_OPTION_KEY = 'tags';
export const UPLOADED_RESPONSE_KEY = 'uploaded_response';
export const WEBHOOK_KEY = 'webhookHandlerApplicationId';

export const SNIPPET_TOKEN_KEY = 'linked_snippet_token';
export const SNIPPET_PUBLIC_VERSION_NUMBER_KEY = 'linked_snippet_public_version_number';
export const SNIPPET_REMOTE_ACTION_MAP_KEY = 'linked_snippet_remote_action_map';

export const REGEX = {
  ACTION_OPTION: /actionoption__\w{20}/,
};
